import JSZip from 'jszip';

/**
 * Bundle multiple files into a single zip blob. Used when the user drops
 * loose .dcm files — the prod ingestion service expects one upload per
 * presigned URL, so multi-file inputs are zipped client-side.
 */
export async function zipFiles(
  files: File[],
  archiveName: string
): Promise<File> {
  const zip = new JSZip();
  files.forEach((f) => {
    zip.file(f.name, f);
  });
  const blob = await zip.generateAsync({ type: 'blob' });
  return new File([blob], archiveName, { type: 'application/zip' });
}

/**
 * Decide what single file gets uploaded.
 *
 * - 1 file (any type) → upload as-is.
 * - 2+ files → zip them client-side into one archive.
 */
export async function prepareUploadPayload(files: File[]): Promise<File> {
  if (files.length === 0) {
    throw new Error('No files to upload');
  }
  if (files.length === 1) {
    return files[0];
  }
  const stamp = new Date()
    .toISOString()
    .replace(/[:.]/g, '-')
    .replace('T', '_')
    .slice(0, 19);
  return zipFiles(files, `study_${stamp}.zip`);
}
